(() => {
  const dialog = document.getElementById('BStorePreorderNotice');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  let pending = null;
  let previousFocus = null;
  let confirmed = false;
  const close = () => {
    if (dialog.open) dialog.close();
  };
  dialog.querySelectorAll('[data-bstore-preorder-close]').forEach(button => button.addEventListener('click', close));
  dialog.querySelector('[data-bstore-preorder-confirm]').addEventListener('click', () => {
    confirmed = true;
    close();
  });
  dialog.addEventListener('close', () => {
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
    const resolve = pending;
    pending = null;
    if (resolve) resolve(confirmed);
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
  });
  window.BStorePreorderNotice = {
    show(form) {
      const field = form.querySelector('[data-bstore-preorder-message]');
      if (!field || !field.value) return Promise.resolve(true);
      if (pending) return Promise.resolve(false);
      confirmed = false;
      dialog.querySelector('[data-bstore-preorder-product]').textContent = field.dataset.productTitle;
      dialog.querySelector('[data-bstore-preorder-copy]').textContent = field.value;
      previousFocus = document.activeElement;
      return new Promise(resolve => {
        pending = resolve;
        try {
          dialog.showModal();
        } catch (error) {
          pending = null;
          resolve(false);
        }
      });
    }
  };
})();
